import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('my-approvals', storeModule.createStoreModule('my-approvals'))
